import "./src/styles/global.css";